import React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import InputAdornment from '@mui/material/InputAdornment';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { Container } from '@mui/material';
import ja from 'date-fns/locale/ja'

function PersonalGoals(){
  const [value1, setValue1] = React.useState(null);
  const [value2, setValue2] = React.useState(null);

  const handleChange1 = (newValue) => {
    setValue1(newValue)
  }

  const handleChange2 = (newValue) => {
    setValue2(newValue)
  }

  function createData(name, data) {
    return { name, data };
  }

  function createData_jousui(name, data1, data2, data3, data4) {
    return { name, data1, data2, data3, data4 };
  }

  const rows = [
    createData('目標件数', 100),
    createData('目標金額', 1000000),
    createData('管理成約目標', 100),
    createData_jousui('浄水器目標', 101, 102, 103, 104),
    createData('オーナー訪問目標件数', 100),
    createData('管理受託目標件数', 100),
    createData('一般受託目標件数', 100),
    createData('入居率成約数目標件数', 100),
  ];
  
  return (
    <Box className="App" id="content">
      <Grid container columns={12} gap={2} direction="row" justifyContent="center" alignItems="stretch" className="container">
        <Grid item xs={12} className="tab-list">
          <Container>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
              <DatePicker
                label="開始日"
                value={value1}
                onChange={handleChange1}
                  inputFormat='yyyy年MM月dd日'
                  mask='____年__月__日'
                renderInput={(params) => <TextField {...params} sx={{ mr: 1 }} />}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
              <DatePicker
                label="最終日"
                value={value2}
                onChange={handleChange2}
                  inputFormat='yyyy年MM月dd日'
                  mask='____年__月__日'
                renderInput={(params) => <TextField {...params} sx={{ mr: 1 }} />}
              />
            </LocalizationProvider>
            <FormControl sx={{width: 300}}>
            <InputLabel id="demo-simple-select-label">店舗</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              // value={age}
              // defaultValue={2}
              label="店舗"
              // onChange={handleChange}
            >
              <MenuItem value={1}>番町店</MenuItem>
              <MenuItem value={2}>レインボーロード店</MenuItem>
              <MenuItem value={3}>高松駅前店</MenuItem>
            </Select>
            </FormControl>
          </Container>
          {/* <Container sx={{mt: 2, mb: 2}}>
            <Stack spacing={2} direction="row" sx={{justifyContent: 'right'}}>
              <Button variant="contained" color='success' startIcon={<DownloadIcon />}>ダウンロード</Button>
              <Button variant="contained" startIcon={<SummarizeIcon />}>WEB日報</Button>
              <Button variant="outlined" startIcon={<SummarizeIcon />}>新WEB日報入力</Button>
            </Stack>
          </Container>
          <Container>
            <Stack spacing={2} direction="row" sx={{justifyContent: 'right'}}>
              <Typography sx={{fontSize: 16}}>WEB日報原紙</Typography>
              <Button variant="outlined" startIcon={<SummarizeIcon />}>ファイルを選択</Button>
              <Button variant="contained" startIcon={<FileUploadIcon />}>アップロード</Button>
            </Stack>
          </Container> */}
        </Grid>
        <Grid item xs={12} className="tab-list">
          <TableContainer component={Paper} elevation={0}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontSize: 20, fontWeight: 'bold'}}>目標設定</TableCell>
                  <TableCell sx={{fontSize: 20}} align="right">2023年02月</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    {row.name === '浄水器目標' ?
                    <TableCell align="right">
                      <TextField
                        label="第1週"
                        defaultValue={row.data1.toLocaleString()}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">件</InputAdornment>
                        }}
                        sx={{width: 150}}
                      />
                      <TextField
                        label="第2週"
                        defaultValue={row.data2.toLocaleString()}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">件</InputAdornment>
                        }}
                        sx={{width: 150}}
                      />
                      <TextField
                        label="第3週"
                        defaultValue={row.data3.toLocaleString()}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">件</InputAdornment>
                        }}
                        sx={{width: 150}}
                      />
                      <TextField
                        label="第4週"
                        defaultValue={row.data4.toLocaleString()}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">件</InputAdornment>
                        }}
                        sx={{width: 150}}
                      />
                    </TableCell>
                  : <TableCell align="right">
                      <TextField
                        defaultValue={row.data.toLocaleString()}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">
                            {row.name === '目標金額' ? "円" : row.name === '管理成約目標' ? "　" : row.name === '入居率成約数目標件数' ? "室" : "件"}
                          </InputAdornment>
                        }}
                      />
                    </TableCell>
                    }

                    {/* <TableCell align="right">
                      <TextField
                        // defaultValue={row.data}
                        size="small"
                        InputProps={{
                          endAdornment: <InputAdornment position="start">
                            {row.name === '目標金額' ? "円" : row.name === '管理成約目標' ? "　" : row.name === '入居率成約数目標件数' ? "室" : "件"}
                          </InputAdornment>,
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                ))}
                {/* {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.data}</TableCell>
                  </TableRow>
                ))} */}
              </TableBody>
            </Table>
          </TableContainer>
          <Button variant="contained" color='success'>目標登録</Button>
        </Grid>
      </Grid>

      {/* <Grid container columns={10} gap={2} spacing={{lg:2,xs:1,}} direction="row" justifyContent="center" alignItems="stretch" className="container">
        <Grid item xs={12} lg={3} style={{width:'400px'}} className="news_table">
          <NewsTable toggleState={updateState} List={stateList}/>
        </Grid>
        <Grid item xs={12} lg={6.5} className="news_container">
          <NewsContents Contents={stateProp} updateList={updateList}/>
        </Grid>
      </Grid> */}
      
      {/* <Route path='/Recruit' component={Recruit} /> */}
      <style jsx="true">{
        `
        .css-15wwp11-MuiTableHead-root{
          display: table-header-group;
        }
        .css-1iezzy6-MuiFormControl-root-MuiTextField-root{
          margin-left: 8px;
        }
        .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input{
          text-align: right;
        }
        @media screen and (max-width: 1000px){
          .css-177gid-MuiTableCell-root{
            display: grid;
            justify-content: right;
          }
          .css-1iezzy6-MuiFormControl-root-MuiTextField-root{
            margin-left: 0;
            margin-bottom: 10px;
          }
          .css-15wwp11-MuiTableHead-root{
            display: block;
          }
          .css-quj9j6-MuiTable-root{
            min-width: 0;
          }
          .css-34nofg-MuiTableRow-root{
            display: block;
          }
          .css-1ex1afd-MuiTableCell-root{
            border-bottom: 0;
          }
        }
        @media screen and (max-width: 768px){
          .css-1oqqzyl-MuiContainer-root {
            padding-left: 0;
            padding-right: 0;
          }
          .css-16v8lce-MuiFormControl-root-MuiTextField-root {
            margin-bottom: 8px;
          }
        }
        body {
          background: #E9F2F8;
          color: #292f33;
          font-family: 'Lucida Grande','Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3',Meiryo,メイリオ, sans-serif;
        }
        .GADbox{
          margin: 0 auto;
        }
        .top_box{
          text-align: left;
          padding-bottom:20px;
        }
        .tab-list {
          padding:20px !important;
          background-color: #fff;
          border-radius: 5px;
          margin:0;
        }
        .NewsTitle{
          text-align: left;
          padding-right: 20px;
          font-size:15px;
          font-weight: bold;
        }
        .Table{
          font-size:15px;
        }
        
        .container {
          padding: 0px 20px;
          max-width: 1260px;
          margin-right: auto;
          margin-left: auto;
        }
        
        .news_table{
          background-color:#fff;
          paddnig: 15px !important;
        }

        .news_container{
          background-color:#fff;
          paddnig: 15px !important;
        }

        `
      }
      </style>
    </Box>
  );
};

export default PersonalGoals;
